'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp2;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _SearchBox = require('./SearchBox.scss');

var _SearchBox2 = _interopRequireDefault(_SearchBox);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _search = require('redux/modules/search');

var _suggestion = require('redux/modules/suggestion');

var _session = require('redux/modules/session');

var _search2 = require('utils/search');

var _suggestion2 = require('utils/suggestion');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  SearchBox: {
    displayName: 'SearchBox'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Nav/SearchBox.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import { parseFilterToQuery, matchTextToFilter } from 'utils/search';
// import levenshtein from 'levenshtein-edit-distance';


var SearchBox = _wrapComponent('SearchBox')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    path: state.routing.locationBeforeTransitions.pathname,
    trip: state.trip.data,
    filter: state.search.filter,
    mobileFilter: state.search.mobileFilter,
    results: state.suggestion.results,
    resultIndex: state.suggestion.resultIndex,
    text: state.suggestion.text,
    originalText: state.suggestion.originalText,
    keywords: state.suggestion.keywords,
    destinations: state.search.options.destinations,
    activities: state.search.options.activities,
    messages: state.language.messages
    // userConfig: state.info.userConfig,
  };
}, (0, _extends3.default)({}, _reactRouterRedux.routerActions, { search: _search.search, openMobileFilter: _search.openMobileFilter, searchSuggestion: _search.searchSuggestion, prepFilter: _search.prepFilter, openMobileNav: _session.openMobileNav, goUp: _suggestion.goUp, goDown: _suggestion.goDown, goTo: _suggestion.goTo, clearResults: _suggestion.clearResults, setText: _suggestion.setText, getResults: _suggestion.getResults, goToAndSet: _suggestion.goToAndSet })), _dec2 = (0, _reactCssModules2.default)(_SearchBox2.default), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(SearchBox, _Component);

  function SearchBox() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SearchBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SearchBox.__proto__ || (0, _getPrototypeOf2.default)(SearchBox)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (e) {
      var value = e.target.value;
      // if (!value) {
      //   this.clearInput();
      // } else {
      // this.props.setText(e.target.value);
      _this.props.setText(e.target.value);
      _this.props.getResults(value);
      // setTimeout(() => this.getResults(value), 300);
      // }
    }, _this.getResults = function (value) {
      if (value === _this.props.text) {
        _this.props.getResults(value);
      }
    }, _this.getChoice = function () {
      // if (this.props.userConfig.suggestionEnabled && !this.props.text) {
      if (!_this.props.text) {
        _this.props.getResults('');
      }
    }, _this.clearInput = function () {
      // if (this.props.userConfig.suggestionEnabled) {
      //   this.props.getResults('');
      // } else {
      //   this.props.clearResults();
      //   this.props.setText();
      // }
      // this.props.getResults('');
      _this.props.clearResults();
      _this.props.setText();
      // setTimeout(()=> {
      //   this.refs.searchInput.value = '';
      //   console.log('text', this.props.text);
      // }, 2000);
    }, _this.handleKeyDown = function (e) {
      if (e.keyCode === 38) {
        _this.props.goUp();
        e.preventDefault();
      }
      if (e.keyCode === 40 || e.keyCode === 9) {
        _this.props.goDown();
        e.preventDefault();
      }
      if (e.keyCode === 13 && _this.props.resultIndex !== -1) {
        // this.props.goToAndSet(this.props.resultIndex);
        e.preventDefault();
        _this.handleMouseClick(_this.props.resultIndex);
      }
    }, _this.handleMouseOver = function (index) {
      _this.props.goTo(index);
    }, _this.handleMouseClick = function (index) {
      var _this$props = _this.props,
          filter = _this$props.filter,
          path = _this$props.path,
          mobileFilter = _this$props.mobileFilter,
          results = _this$props.results,
          originalText = _this$props.originalText;
      // const sessionId = Math.random().toString(36).substring(7);

      _this.props.goToAndSet(index); // Set first
      if (path.startsWith('/search')) {
        var newFilter = _lodash2.default.cloneDeep((0, _extends3.default)({}, _search2.defaultFilter, { session_id: filter.session_id, quantity: filter.quantity, text: results[index], raw_keyword: _this.props.originalText, click_suggest: true }));
        // const newFilter = _.cloneDeep({...filter, text: results[index], raw_keyword: this.props.originalText, click_suggest: true});
        (0, _search2.matchTextToFilter)(newFilter, _this.props.destinations, _this.props.activities, _this.props.keywords);
        _this.props.prepFilter(newFilter, true);
        // if (!mobileFilter) {
        //   if (newFilter.text) {
        //     this.props.searchSuggestion(newFilter.text);
        //   }
        //   this.props.search(newFilter);
        // }
        _this.props.setText(newFilter.text);
        if (newFilter.text) {
          _this.props.searchSuggestion(newFilter.text);
        }
        if (mobileFilter) {
          _this.props.openMobileFilter(false);
        }
        _this.props.search(newFilter);
      } else {
        // this.props.push(`/search?text=${escape(this.props.results[index])}&raw_keyword=${this.props.originalText}&session_id=${sessionId}&click_suggest=true`);
        _this.props.push('/search/Any?text=' + encodeURIComponent(results[index]) + '&raw_keyword=' + encodeURIComponent(originalText) + '&click_suggest=true');
      }
      // this.props.clearResults();
      _this.refs.searchInput.blur();
    }, _this.handleSubmit = function (e) {
      e.preventDefault();
      var _this$props2 = _this.props,
          resultIndex = _this$props2.resultIndex,
          filter = _this$props2.filter,
          path = _this$props2.path,
          mobileFilter = _this$props2.mobileFilter,
          text = _this$props2.text,
          originalText = _this$props2.originalText;
      // const {resultIndex, filter, mobileFilter, text} = this.props;
      // const sessionId = Math.random().toString(36).substring(7);

      if (resultIndex === -1) {
        if (path.startsWith('/search')) {
          var newFilter = _lodash2.default.cloneDeep((0, _extends3.default)({}, _search2.defaultFilter, { session_id: filter.session_id, quantity: filter.quantity, text: text, raw_keyword: text, click_suggest: false }));
          // const newFilter = _.cloneDeep({...filter, text: text, raw_keyword: text, click_suggest: false});
          (0, _search2.matchTextToFilter)(newFilter, _this.props.destinations, _this.props.activities, _this.props.keywords);
          _this.props.prepFilter(newFilter, true);
          // if (!mobileFilter) {
          //   if (newFilter.text) {
          //     this.props.searchSuggestion(newFilter.text);
          //   }
          //   this.props.search(newFilter);
          // }
          _this.props.setText(newFilter.text);
          if (newFilter.text) {
            _this.props.searchSuggestion(newFilter.text);
          }
          if (mobileFilter) {
            _this.props.openMobileFilter(false);
          }
          _this.props.search(newFilter);
        } else {
          var str = text.replace(/\s+$/, '');
          if (str) {
            _this.props.push('/search/Any?text=' + encodeURIComponent(str) + '&raw_keyword=' + encodeURIComponent(originalText) + '&sort=' + encodeURIComponent('Most relevant'));
            _this.props.setText();
          } else {
            // this.props.push(`/search?sort=Recommended&session_id=${sessionId}`);
            // this.props.push(`/search/Any?sort=Recommended`);
            _this.props.push('/search/Any');
          }
        }
      }
      _this.refs.searchInput.blur();
      // this.props.clearResults();
    }, _this.clearResults = function () {
      _this.props.clearResults();
    }, _this.ignoreFocus = function (e) {
      e.preventDefault();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SearchBox, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          originalText = _props.originalText,
          text = _props.text,
          resultIndex = _props.resultIndex,
          results = _props.results,
          filterStyle = _props.filterStyle,
          messages = _props.messages;

      return _react3.default.createElement(
        'div',
        { styleName: 'searchbox-container' },
        _react3.default.createElement(
          'form',
          { styleName: filterStyle ? 'searchbox-form-filterstyle' : 'searchbox-form', onSubmit: this.handleSubmit, onBlur: this.clearResults },
          _react3.default.createElement('input', { ref: 'searchInput', type: 'search', value: text, onChange: this.onChange, onKeyDown: this.handleKeyDown, styleName: filterStyle ? 'searchbox-input-filterstyle' : 'searchbox-input', placeholder: messages['search.search_filter.search.placeholder'], onFocus: this.getChoice }),
          _react3.default.createElement(
            'div',
            { styleName: filterStyle ? 'action-container-filterstyle' : 'action-container' },
            _react3.default.createElement('button', { type: 'submit', styleName: text ? 'searchbox-button-hide-mobile' : 'searchbox-button', onMouseDown: this.ignoreFocus }),
            _react3.default.createElement('button', { type: 'reset', styleName: 'searchbox-clear-mobile', style: text ? null : { display: 'none' }, onMouseDown: this.ignoreFocus, onClick: this.clearInput })
          ),
          results.length > 0 && _react3.default.createElement(
            'div',
            { styleName: 'results' },
            results.map(function (res, index) {
              var hilightIndexes = (0, _suggestion2.hilightKeyword)(res, originalText);
              return _react3.default.createElement(
                'p',
                { key: index, styleName: index === resultIndex ? 'result-active' : 'result', onMouseOver: _this2.handleMouseOver.bind(_this2, index), onMouseDown: _this2.ignoreFocus, onClick: _this2.handleMouseClick.bind(_this2, index) },
                res.split('').map(function (r, i) {
                  if (hilightIndexes.indexOf(i) >= 0) {
                    return _react3.default.createElement(
                      'span',
                      { styleName: 'result-bold', key: i },
                      r
                    );
                  }
                  return _react3.default.createElement(
                    'span',
                    { key: i },
                    r
                  );
                })
              );
            })
          )
        )
      );
    }
  }]);
  return SearchBox;
}(_react2.Component), _class2.propTypes = {
  onChange: _react2.PropTypes.func,
  push: _react2.PropTypes.func,
  path: _react2.PropTypes.string,
  trip: _react2.PropTypes.object,
  filter: _react2.PropTypes.object,
  mobileFilter: _react2.PropTypes.bool,
  search: _react2.PropTypes.func,
  searchSuggestion: _react2.PropTypes.func,
  prepFilter: _react2.PropTypes.func,
  openMobileNav: _react2.PropTypes.func,
  goUp: _react2.PropTypes.func,
  goDown: _react2.PropTypes.func,
  goTo: _react2.PropTypes.func,
  goToAndSet: _react2.PropTypes.func,
  getResults: _react2.PropTypes.func,
  clearResults: _react2.PropTypes.func,
  setText: _react2.PropTypes.func,
  results: _react2.PropTypes.array,
  resultIndex: _react2.PropTypes.number,
  text: _react2.PropTypes.string,
  originalText: _react2.PropTypes.string,
  keywords: _react2.PropTypes.array,
  destinations: _react2.PropTypes.array,
  activities: _react2.PropTypes.array,
  filterStyle: _react2.PropTypes.bool,
  openMobileFilter: _react2.PropTypes.func,
  messages: _react2.PropTypes.object
  // userConfig: PropTypes.object
}, _class2.defaultProps = {
  filterStyle: false
}, _temp2)) || _class) || _class));

exports.default = SearchBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Nav/SearchBox.js
// module id = 463
// module chunks = 1 35